module.exports = __webpack_public_path__ + "img/daan.7c5edf7d.png";